import { gql } from '@grandvisionhq/graphql';

var StoreDetailsFragment = gql`
  fragment StoreDetails on Store {
    code
    globalStoreId
    slug
    streetName
    streetNumber
    additionalStreetInfo
    postalCode
    town
    province
    country
    lat
    lon
    name
    email
    storeDetailImage
    phone
    description
    storenote
    storeFacilities
    metaDescription
    servicesNotAvailable
    accessibility
    practicalInformation
    hearingAppointmentPossible
    features {
      paymentMethods {
        code
      }
      socialMediaLinks {
        code
        url
      }
      availableBrands {
        name
      }
      productCategories {
        code
      }
    }
    monOpenClose {
      open
      close
    }
    tueOpenClose {
      open
      close
    }
    wedOpenClose {
      open
      close
    }
    thuOpenClose {
      open
      close
    }
    friOpenClose {
      open
      close
    }
    satOpenClose {
      open
      close
    }
    sunOpenClose {
      open
      close
    }
    specialOpenClosingHours {
      openClosed
      dateOpenClosed
      openClosedTime {
        open
        close
      }
    }
    rating {
      value
      count
    }
    breadcrumbName
    breadcrumbSlug
    googlePlaceId
    googlePlaceReviewUrl
    defaultAppointmentTypeId
    storeTypes
  }
`;

export { StoreDetailsFragment as default };
//# sourceMappingURL=store-details.js.map
